const isMotionValue = (value) => !!(value === null || value === void 0 ? void 0 : value.getVelocity);

export { isMotionValue };
